export default __webpack_public_path__ + "static/media/gf-foundation.8e77c3ac.JPG";